"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rolesHeroSections = {
    influencer: {
        title: 'REGISTER_HERO_TITLE_INF',
        description: 'REGISTER_HERO_DESCRIPTION_INF'
    }
};
exports.default = rolesHeroSections;
